import script from "./Login.vue?vue&type=script&setup=true&lang=ts"
export * from "./Login.vue?vue&type=script&setup=true&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=4480af80&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4480af80"]])

export default __exports__